import React from 'react';
import PropTypes from 'prop-types';

import LeadSettingModal from 'components/Modal/LeadSetting';
import IncomingNotifications from './IncomingNotifications';

const IncomingNotificationsModal = ({ open, onClose }) => {

  return (
    <LeadSettingModal
      open={open}
      onClose={onClose}
      title="Edit your lead notifications."
    >
      <IncomingNotifications />
    </LeadSettingModal>
  );
};

IncomingNotificationsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

IncomingNotificationsModal.defaultProps = {};

export default IncomingNotificationsModal;
